import { memo } from 'react'

import SC from 'styled-components'

import { downloadFile } from '../../helpers'
import { Button, ButtonFace } from '../Button'
import { IconName } from '../Icon'

type Properties = {
  baseUrl: string
  parametersForm: any
  handleError?: (error: string) => void
  children?: React.ReactNode
  direct?: boolean
  name?: string
  mimeType?: string
  withIcon?: boolean
  method?: string
}

//region Styled

const Link = SC(Button)`
  color: #000 !important;
  font-weight: normal;
  padding: 0;
`

//endregion

export const DownloadLink = memo((properties: Properties) => {
  const {
    children,
    baseUrl,
    parametersForm,
    direct,
    name,
    mimeType,
    withIcon = true,
    method = 'post',
    handleError
  } = properties

  return (
    <Link
      face={ButtonFace.LINK}
      icon={withIcon ? IconName.DOWNLOAD : undefined}
      onClick={() =>
        downloadFile({
          method,
          baseUrl,
          parametersForm,
          direct,
          mimeType,
          name,
          handleError
        })
      }
      data-qa={`${name}-link`}
    >
      {children}
    </Link>
  )
})
